module.exports = __webpack_public_path__ + "img/AddPosHelp2.52392e3c.png";